<template>
  <div>
    <b-card title="크리에이터 후원 이벤트 리스트" class="creator-event-list-card">
      <div>
        <div class="w-100 text-right">
          <b-button :to="{name:'CreatorPromotionEventCreate'}">
            이벤트 등록
          </b-button>
        </div>
        <div>
          <b-row class="mt-3 mb-3">
            <b-col>
              <div>
                <span v-for="(option, index) in periodStatusOptions">
                  <span v-if="index > 0">|</span>
                  <a @click="periodOptionClicked(option.value)" class="period-option"
                     :class="{'period-option-active':option.value === selectedPeriodStatus}">
                    {{ option.label }}
                  </a>
                </span>
              </div>
            </b-col>
            <b-col class="text-right">
              <div>
                <b-input-group prepend="검색">
                  <b-input v-model="searchText" placeholder="게임명 또는 이벤트명 입력"></b-input>
                </b-input-group>
              </div>
            </b-col>
          </b-row>
          <b-table id="creator-event-table" :fields="fields" :items="filteredCreatorEventList" :current-page="currentPage" :per-page="perPage">
            <template slot="appId" slot-scope="data">
              {{ data.item.appName }} ({{ data.item.appId }})
            </template>
            <template slot="url" slot-scope="data">
              <a :href="`http://alpha-game.kakao.com/cr/${data.item.codeName}`" target="_blank">바로가기</a>
            </template>
            <template slot="creatorApplicableTime" slot-scope="data">
              {{ data.item.creatorApplicableStartTime }} ~ <br>
              {{ data.item.creatorApplicableEndTime }}
            </template>
            <template slot="paymentAccruedTime" slot-scope="data">
              {{ data.item.paymentAccruedStartTime }} ~ <br>
              {{ data.item.paymentAccruedEndTime }}
            </template>
            <template slot="donationTime" slot-scope="data">
              {{ data.item.donationStartTime }} ~ <br>
              {{ data.item.donationEndTime }}
            </template>
            <template slot="management" slot-scope="data">
              <router-link :to="{name:'CreatorPromotionEventEdit', params:{id:data.item.id}}">정보수정</router-link>
              |
              <router-link :to="{name:'CreatorPromotionList', params:{id:data.item.id}}">크리에이터 관리</router-link>
            </template>
          </b-table>
          <nav>
            <b-pagination aria-controls="creator-event-table"
                          :total-rows="filteredCreatorEventList.length" :per-page="perPage"
                          v-model="currentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </div>
      </div>
    </b-card>
  </div>

</template>

<script>

import creatorPromotionApi from "@/common/creatorPromotion/api/creatorPromotionApi";
import moment from "moment";

export default {
  name: "CreatorEventList",
  data() {

    const periodStatusText = {
      "STARTED": "진행중",
      "NOT_STARTED": "진행예정",
      "ENDED": "종료"
    }

    const fields = [
      {key: "appId", label: "게임명(capri app id)"},
      {key: "name", label: "이벤트명"},
      {key: "url", label: "주소"},
      {key: "creatorApplicableTime", label: "크리에이터 신청"},
      {key: "paymentAccruedTime", label: "결제적립"},
      {key: "donationTime", label: "응원(후원)"},
      {key: "eventEndTime", label: "정산 종료"},
      {key: "periodStatus", label: "상태", formatter: (v) => periodStatusText[v]},
      {key: "management", label: "관리"}
    ];

    fields.forEach(elm => {
      elm.tdClass = (v, k, item) => item.periodStatus === "STARTED" ? 'started-event' : '';
    })

    return {
      fields,
      creatorEventList: [],
      searchText: "",

      selectedPeriodStatus: null,
      periodStatusOptions: [
        {label: "전체", value: null},
        {label: "진행중", value: "STARTED"},
        {label: "진행예정", value: "NOT_STARTED"},
        {label: "종료", value: "ENDED"}
      ],

      currentPage: 0,
      perPage: 10,

      periodStatusText
    }
  },
  computed: {
    filteredCreatorEventList() {
      return this.creatorEventList.filter(elm => (
                                                     elm.appName.includes(this.searchText) ||
                                                     elm.name.includes(this.searchText)
                                                 )
                                                 &&
                                                 (this.selectedPeriodStatus === null || elm.periodStatus === this.selectedPeriodStatus));
    }
  },
  mounted() {
    creatorPromotionApi.getCreatorEvents().then(response => {
      console.log(response);
      let creatorEventList = response.data.data;
      creatorEventList.forEach(elm => {
        elm.periodStatus = this.getPeriodStatus(elm);
      })

      // 이벤트 시간 최근순서로 정렬
      creatorEventList = creatorEventList.sort((a, b) =>
                                                   a.eventStartTime < b.eventStartTime ? 1 :
                                                   a.eventStartTime > b.eventStartTime ? -1 :
                                                   0
      );

      // 이벤트 진행 상태로 정렬 (진행중 -> 예정 -> 종료)
      creatorEventList = creatorEventList.sort((a, b) => {
        if (a.periodStatus === b.periodStatus) {
          return 0;
        }
        if (a.periodStatus === "STARTED") {
          return -1;
        } else if (b.periodStatus === "STARTED") {
          return 1;
        }
        if (a.periodStatus === "NOT_STARTED") {
          return -1;
        } else if (b.periodStatus === "NOT_STARTED") {
          return 1;
        }
      });

      this.creatorEventList = creatorEventList;
    });
  },
  methods: {
    getPeriodStatus(creatorEvent) {
      const eventStartMoment = moment(creatorEvent.eventStartTime);
      const eventEndMoment = moment(creatorEvent.eventEndTime);
      const nowMoment = moment();

      return nowMoment.isBefore(eventStartMoment) ? "NOT_STARTED" :
             nowMoment.isBetween(eventStartMoment, eventEndMoment) ? "STARTED" :
             "ENDED";
    },
    periodOptionClicked(value) {
      this.selectedPeriodStatus = value;
      this.currentPage = 0;
    }
  }
}

</script>

<style scoped>
.period-option {
  cursor: pointer;
}

a.period-option-active {
  font-weight: bold;
}

</style>

<style>
.creator-event-list-card td.started-event {
  background-color: rgba(255, 255, 0, 0.29);
}
</style>
